import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

const CategorySectionCreator = ({ title, subtitle, children }) => {
  return (
    <Box sx={{ mb: 6, mt: 6 }}>
      <Container maxWidth="xl">
        <Box
          sx={{
            textAlign: 'center',
            mb: 5,
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: '-16px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '48px',
              height: '1px',
              backgroundColor: 'gold.fill'
            }
          }}>
          <Typography
            variant="h2"
            sx={{
              color: 'text.primary',
              mb: 2
            }}>
            {title}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontFamily: 'inherit',
              fontWeight: 400,
              fontSize: { xs: '1rem', md: '1.25rem' },
              color: 'text.secondary',
              maxWidth: '800px',
              mx: 'auto',
              lineHeight: 1.6
            }}>
            {subtitle}
          </Typography>
        </Box>
        {children}
      </Container>
    </Box>
  );
};

CategorySectionCreator.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default CategorySectionCreator;
